module.exports = __webpack_public_path__ + "static/img_9636-9cb08a4c43122aaac2ae60e6a3e3b16d.webp";